import React, { useContext, useEffect, useMemo, useState } from "react";
import { BASE_FILE_URL } from "../../constant";
import { formatDate } from "@telerik/kendo-intl";
import { LiveDataQualityStatus } from "../LiveDataQualityCircle";
import { forwardRef } from "react";
import { useImperativeHandle } from "react";
import AppContext from "../../AppContext";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import { useTranslation } from "react-i18next";
import PlayBackDataQualityCircle from "../PlayBackDataQualityCircle";

const Details = forwardRef(
  (
    {
      assetData,
      expanded,
      playBackMode,
      momentData,
      currentPlayTime,
      assetConfig,
      assetType,
      loadedAssetIsChild,
    },
    ref
  ) => {
    const { getTimeZoneDateTime } = useContext(AppContext);
    const { t } = useTranslation();
    const [momentSensorData, setMomentSensorData] = useState();

    useImperativeHandle(ref, () => ({
      clearChildState() {
        setMomentSensorData(null);
      },
    }));

    const findSensorParameter = (id) => {
      const param = assetData?.parameters.find((s) => s.id === id);
      return param;
    };

    const findSensorDevice = (deviceId) => {
      const device = assetData.devices.find((d) => d.device.id === deviceId);
      return device;
    };

    const imgurl = useMemo(() => {
      return assetData?.imageId &&
        !assetData?.imageId.startsWith("00000") &&
        assetData?.imageId !== null &&
        assetData?.imageId !== ""
        ? BASE_FILE_URL + "/" + assetData.imageId
        : "";
    }, [assetData?.imageId]);

    const findMatchingObject = (mappingObject, sensorValue, paramType) => {
      for (const item of mappingObject.data) {
        if (paramType === "Number")
          if (item.value.includes("-")) {
            const [startRange, endRange] = item.value.split("-");
            const parsedStartRange = parseFloat(startRange.trim());
            const parsedEndRange = parseFloat(endRange.trim());
            if (
              sensorValue >= parsedStartRange &&
              sensorValue <= parsedEndRange
            ) {
              return item;
            }
          } else {
            const parsedSensorValue = parseFloat(sensorValue);
            const parsedItemValue = parseFloat(item.value.trim());
            if (parsedSensorValue === parsedItemValue) {
              return item;
            }
          }
        else if (paramType === "String") {
          const parsedSensorValue = sensorValue;
          const parsedItemValue = item.value.trim();
          if (parsedSensorValue === parsedItemValue) {
            return item;
          }
        } else if (paramType === "Boolean") {
          let parsedItemValue;
          let valueString = sensorValue.ToString();
          let itemValue = item.Value === "True";

          switch (valueString) {
            case "0":
              parsedItemValue = false;
              break;
            case "1":
              parsedItemValue = true;
              break;
            default:
              parsedItemValue = parseBoolean(valueString);
              break;
          }
          //var parsedItemValue = bool.Parse(item.Value);
          if (itemValue === parsedItemValue) {
            return item;
          }
        }
      }
      if (mappingObject.unknownValue) {
        const unknownData = mappingObject.data.find(
          (x) => x.value === "unknown"
        );
        return unknownData;
      } else return null; // Return null if no matching object is found
    };

    const parseBoolean = (valueString) => {
      if (valueString.toLowerCase() === "true") {
        return true;
      } else if (valueString.toLowerCase() === "false") {
        return false;
      } else {
        return false; // default value in case of failure
      }
    };

    const playbackMomentData = (parameter) => {
      if (momentSensorData && momentSensorData?.Values && parameter) {
        const data = momentSensorData?.Values.find(
          (v) =>
            assetData.id === v.AssetId &&
            v.ParameterId === parameter.parameterId &&
            parameter.sensorId === v.Id
        );
        if (data) return data.Value;
        else return null;
      }
    };

    const toolTipContent = (parameter, mappingObj) => {
      return (
        <span className="flex flex-col leading-4 items-center space-y-0 text-xxs">
          <span className="w-fit truncate h-full">
            {playBackMode === 200
              ? momentSensorData?.timeStamp &&
                formatDate(
                  getTimeZoneDateTime(momentSensorData.timeStamp),
                  "dd MMM yyyy hh:mm:ss a"
                )
              : playBackMode === 100 &&
                parameter?.timeStamp &&
                formatDate(
                  getTimeZoneDateTime(parameter.timeStamp),
                  "dd MMM yyyy hh:mm:ss a"
                )}
          </span>
          {(parameter?.mappings?.displayOption === 100 ||
            parameter?.mappings?.displayOption === 300) &&
            mappingObj?.description}
        </span>
      );
    };

    useEffect(() => {
      if (playBackMode === 200 && momentData && momentData.data) {
        setMomentSensorData(momentData.data);
      }
    }, [momentData?.data]);

    return (
      <>
        {assetData && assetData.devices.length !== 0 && (
          <div className=" dark:bg-black bg-[#9D9DA1] px-3 py-2 dark:text-white text-black  text-xs">
            {assetData.devices.map((d, index) => (
              <div
                className="w-full flex gap-2 justify-around items-center"
                key={index}
              >
                <div className="flex mt-1 md:text-xs text-xxs lg:text-sm">
                  {assetData?.timeStamp && playBackMode === 100 ? (
                    assetData?.timeStamp && (
                      <LiveDataQualityStatus
                        timeStamp={assetData?.timeStamp}
                        enabled={true}
                        interval={d.device.interval}
                        parameterName={assetData.name}
                        renderType={"details"}
                        parameterId={assetData.id}
                      />
                    )
                  ) : (
                    <PlayBackDataQualityCircle
                      timeStamp={momentSensorData?.timeStamp}
                      enabled={true}
                      interval={d.device.interval}
                      parameterName={assetData.name}
                      currentPlayTime={currentPlayTime}
                      parameterId={assetData.id}
                    />
                  )}
                </div>
                <div className="flex flex-col gap-2 md:text-xs text-xxs lg:text-sm">
                  <span>{t("assetDetails.details.deviceLabel")}</span>
                  <span className="text-xxs text-slate-400">
                    {d.device.name}
                  </span>
                </div>
                {assetData.parameters
                  .filter(
                    (s) => s.default && s.deviceId === d.device.id && s.enabled
                  )
                  .map((p) => {
                    const sensorValue =
                      playBackMode === 200
                        ? playbackMomentData(p)
                        : playBackMode === 100 && p.value;
                    const mappingObj = p.mappings
                      ? findMatchingObject(p.mappings, sensorValue, p.type)
                      : null;
                    return (
                      <div
                        className="details flex flex-col gap-2 md:text-xxs text-xxxs lg:text-sm"
                        key={p.id}
                      >
                        <span>{p.name}</span>
                        <TooltipComponent
                          content={mappingObj?.description}
                          delayUpdate={false}
                          key={p.id}
                          immediateRender
                          opensOn={
                            p.mappings?.displayOption === 100 ||
                            p.mappings?.displayOption === 300
                              ? "Hover"
                              : "custom"
                          }
                        >
                          {mappingObj && (
                            <div className="md:text-xxs text-xxxs w-full h-6 flex justify-center items-center gap-1  text-slate-400">
                              {/* {(p.mappings?.displayOption === 100 ||
                                p.mappings?.displayOption === 300) && (
                                <span className="tooltiptext w-fit truncate text-xs"></span>
                              )} */}
                              {!mappingObj.iconId.startsWith("00000") &&
                                mappingObj.iconId !== null &&
                                mappingObj.iconId !== "" && (
                                  <img
                                    src={`${BASE_FILE_URL}/${mappingObj.iconId}`}
                                    alt="hintIcon"
                                    className="h-5 lg:h-full w-auto object-cover overflow-hidden hover:fill-white"
                                  />
                                )}
                              <div className="w-fit">
                                {p.mappings.displayOption === 100
                                  ? sensorValue
                                  : (p.mappings.displayOption === 200 ||
                                      p.mappings.displayOption === 400) &&
                                    mappingObj.description}
                                <span>&nbsp;{p?.unit}</span>
                              </div>
                            </div>
                          )}
                        </TooltipComponent>
                      </div>
                    );
                  })}
              </div>
            ))}
          </div>
        )}

        <div
          className={`flex flex-col ${
            expanded !== null
              ? "h-4/5"
              : assetType === "asset" || loadedAssetIsChild
              ? "h-4/6"
              : "h-full"
          }  image-full justify-between px-2`}
          style={{
            backgroundImage: imgurl !== "" ? `url(${imgurl})` : "none",
            backgroundSize: "100%",
            backgroundRepeat: "no-repeat",
            objectFit: "cover",
            backgroundPosition: "center",
          }}
        >
          {/* <div className="flex justify-center mt-1 pt-1"> */}
          <div className="grid grid-cols-5 h-auto w-auto text-black gap-2 text-left mb-5 mt-1 z-50">
            {assetData?.properties
              ?.filter((x) => !x.isLocation)
              .map((item, index) => (
                <div className="text-left" key={index}>
                  <div
                    className={`${
                      index === 0 ? "" : ""
                    } flex-col px-3 py-1 w-auto min-h-[40px] md:text-xs text:xxs lg:text-sm shadow text-slate-200 border-gray-400 border bg-black bg-opacity-70 rounded`}
                    key={index}
                    id={item.key}
                  >
                    <div className="md:text-xs text-xxs font-medium">
                      {item.value && item.value}
                    </div>
                    <div className="md:text-xxs text-xxxs font-normal text-slate-400">
                      {item.key}
                    </div>
                  </div>
                </div>
              ))}
          </div>
          {/* </div> */}
          {/* <div className="absolute top-0 left-0 right-0 bottom-0 backdrop-filter backdrop-blur-lg z-10"></div> */}
          {/* <div className="flex justify-center mt-1 pb-12"> */}
          <div className=" grid grid-cols-4 md:max-h-44 max-h-28 lg:max-h-32 h-auto overflow-y-auto w-auto hide-scroll gap-x-1 text-black text-left z-50">
            {assetConfig &&
              assetConfig.parameters
                ?.sort((a, b) => a.orderIndex - b.orderIndex)
                .map((item, index) => {
                  const parameter = findSensorParameter(item.id);
                  const sensorData =
                    playBackMode === 200
                      ? playbackMomentData(parameter)
                      : playBackMode === 100 && parameter?.value;
                  const device = parameter
                    ? findSensorDevice(parameter.deviceId)
                    : null;
                  const mappingObj = parameter?.mappings
                    ? findMatchingObject(parameter.mappings, sensorData)
                    : null;
                  return (
                    <div className="text-left" key={index}>
                      <div
                        className={`${
                          index === 0 ? "" : ""
                        } flex-col relative pr-2 pl-2 lg:pl-5 min-w-40 md:h-20 h-12 lg:h-14 shadow text-slate-200 bg-black bg-opacity-70 py-1 mb-1 border-gray-400 border rounded`}
                      >
                        <div className="flex justify-between">
                          <TooltipComponent
                            content={() =>
                              toolTipContent(parameter, mappingObj)
                            }
                            opensOn={sensorData ? "Hover" : "custom"}
                          >
                            <div className="md:text-sm tooltip text-xs font-medium transition-all delay-150 duration-200 ease-out">
                              {assetData && !parameter?.enabled ? (
                                <div className="md:text-xxs text-xxxs text-red-500 font-semibold">
                                  {t("home.assetList.disabled")}
                                </div>
                              ) : !mappingObj ? (
                                <div>
                                  {sensorData && parameter.type === "Number"
                                    ? parseFloat(
                                        parseFloat(sensorData).toFixed(2)
                                      )
                                    : sensorData}
                                  &nbsp;{parameter?.unit}
                                </div>
                              ) : (
                                <div className="h-full flex gap-2">
                                  {!mappingObj.iconId.startsWith("00000") &&
                                    mappingObj.iconId !== null &&
                                    mappingObj.iconId !== "" && (
                                      <img
                                        src={`${BASE_FILE_URL}/${mappingObj.iconId}`}
                                        alt="hintIcon"
                                        className="h-5 w-auto object-cover overflow-hidden hover:fill-white"
                                      />
                                    )}
                                  {/* <div className=""> */}
                                  {parameter.mappings.displayOption === 100 ? (
                                    <span className="text-sm">
                                      {sensorData && parameter.type === "Number"
                                        ? parseFloat(
                                            parseFloat(sensorData).toFixed(2)
                                          )
                                        : sensorData}
                                    </span>
                                  ) : (
                                    (parameter.mappings.displayOption === 200 ||
                                      parameter.mappings.displayOption ===
                                        400) && (
                                      <span className="text-xxs leading-snug my-auto">
                                        {mappingObj.description}
                                      </span>
                                    )
                                  )}
                                  <span>&nbsp;{parameter?.unit}</span>
                                </div>
                              )}
                            </div>
                          </TooltipComponent>
                          {parameter?.enabled &&
                            device &&
                            (playBackMode === 100 ? (
                              parameter?.timeStamp && (
                                <LiveDataQualityStatus
                                  timeStamp={parameter?.timeStamp}
                                  enabled={true}
                                  interval={device.device.interval}
                                  parameterName={parameter.name}
                                  parameterId={parameter.id}
                                  renderType={"details"}
                                />
                              )
                            ) : (
                              <PlayBackDataQualityCircle
                                timeStamp={momentSensorData?.timeStamp}
                                enabled={true}
                                interval={device.device.interval}
                                parameterName={parameter.name}
                                currentPlayTime={currentPlayTime}
                                parameterId={parameter.id}
                              />
                            ))}
                        </div>
                        <div className="md:text-xxs text-xxxs font-medium text-opacity-100 text-slate-400">
                          {parameter?.name}
                        </div>
                        {assetConfig?.showLinkedDevice && (
                          <div className="md:text-xxs text-xxxs font-normal">
                            {assetData &&
                              assetData.devices.find(
                                (d) => d.device.id === parameter?.deviceId
                              )?.device.name}
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
          </div>
        </div>
      </>
    );
  }
);

export default Details;
